import { Icon, Tooltip } from "@blueprintjs/core"
import { Dispatch, SetStateAction, useCallback } from "react"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { MediumText } from "../../../../styled/text.styled"
import { transformNumberToStringWithSuffix } from "../utils/transformNumber"
import { getWaveStatusIcon, waveStatusColor } from "../utils/waveStatusColor"
import {
  ContentContainer,
  StatusBorder,
  TickerContainer,
  WaveCardContainer,
} from "./WaveCard.styled"
import WaveTickerList from "./WaveTickerList"
import { Wave } from "./types/wave"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

interface IWaveCard {
  wave: Wave
  selected: boolean
  setSelectedWaveId: Dispatch<SetStateAction<string | number | undefined>>
}

const WaveCard = ({ wave, selected, setSelectedWaveId }: IWaveCard) => {
  /**
   * When WaveCard is clicked, we set it selected
   */
  const onClickCard = useCallback(() => {
    setSelectedWaveId(wave.id)
  }, [setSelectedWaveId, wave.id])

  const statusColor = waveStatusColor(wave.status)
  const statusIcon = getWaveStatusIcon(wave.status)

  return (
    <WaveCardContainer selected={selected} onClick={onClickCard}>
      <StatusBorder statusColor={statusColor} />
      <ContentContainer>
        <Tooltip content={wave.status}>
          <Icon icon={statusIcon} size={18} color={statusColor} />
        </Tooltip>

        <TickerContainer flexGrow={1}>
          <WaveTickerList orders={wave.orders} />
        </TickerContainer>
        <FlexContainer flexDirection="column" alignItems="flex-end">
          <MediumText color={SCIENT_COLORS.gray4}>CREATED</MediumText>
          <MediumText>
            {new Date(wave.created_at).toLocaleDateString(undefined, {
              month: "numeric",
              day: "numeric",
            })}
          </MediumText>
        </FlexContainer>
        <FlexContainer flexDirection="column" alignItems="flex-end">
          <MediumText color={SCIENT_COLORS.gray4}>GMV</MediumText>
          <MediumText>{wave.gmv ? transformNumberToStringWithSuffix(wave.gmv) : "N/A"}</MediumText>
        </FlexContainer>
        <FlexContainer flexDirection="column" alignItems="flex-end">
          <MediumText color={SCIENT_COLORS.gray4}>BUY</MediumText>
          <MediumText>
            {wave.dollar_bought ? transformNumberToStringWithSuffix(wave.dollar_bought) : "N/A"}
          </MediumText>
        </FlexContainer>
        <FlexContainer flexDirection="column" alignItems="flex-end">
          <MediumText color={SCIENT_COLORS.gray4}>SELL</MediumText>
          <MediumText>
            {wave.dollar_sold ? transformNumberToStringWithSuffix(wave.dollar_sold) : "N/A"}
          </MediumText>
        </FlexContainer>
      </ContentContainer>
    </WaveCardContainer>
  )
}

export default WaveCard
